import { cn } from '@/lib/utils';

/** Initial of the shown name in a neutral circle: the board carries no photos. */
export function ContributorAvatar({ name, className }: { name: string; className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cn('grid size-8 shrink-0 place-items-center rounded-full bg-surface-2 text-xs font-semibold text-muted-foreground', className)}
    >
      {(name.trim()[0] ?? '?').toUpperCase()}
    </span>
  );
}
